<template>
  <div class="content">
    <div v-if="iscn" class="title-earth">拯救世界进展</div>
    <div v-if="iscn" class="text-earth text-quick1">
      <p>转转一直致力于减少碳排放，</p>
      <p>截至2025年末，我们已经通过循环经济做出许多成果：</p>
    </div>
    <div v-if="!iscn" class="text-earth-en text-quick1">
      <p class="line1">Our Progress</p>
      <p class="line2">By promoting second-hand trade, we, together with our 300 million users,</p>
      <p class="line2">have contributed to million tons of carbon reduction.</p>
    </div>
    <div class="logo-earth">
      <div class="logo-earth-main"></div>
      <div class="logo-earth-star logo-earth-star-slow"></div>
    </div>
    <div v-if="iscn" class="text-data text-slow">
      <div class="data">
        <div class="data-number">634.82</div>
        <div class="data-text">万吨</div>
        <div class="data-text2">累计GHG减排</div>
      </div>
      <div class="data">
        <div class="data-number">8712</div>
        <div class="data-text">吉瓦时</div>
        <div class="data-text2">累计能源减耗</div>
      </div>
      <div class="data">
        <div class="data-number">3338</div>
        <div class="data-text">万册</div>
        <div class="data-text2">累计二手图书交易</div>
      </div>
    </div>
    <div v-if="!iscn" class="text-data text-data-en text-slow">
      <div class="data">
        <div class="data-number">634.82</div>
        <div class="data-text">Ten thousand tons</div>
        <div class="data-text2">cumulative GHG emissions reduced</div>
      </div>
      <div class="data">
        <div class="data-number">8712</div>
        <div class="data-text">GWh</div>
        <div class="data-text2">cumulative energy savings</div>
      </div>
      <div class="data">
        <div class="data-number">3338</div>
        <div class="data-text">Ten thousand</div>
        <div class="data-text2">second-hand books traded</div>
      </div>
    </div>
    <!-- <div v-if="iscn" class="banner-logo banner-logo-slow">
      <p class="line1">咦,什么是碳减排？</p>
      <p>为什么要碳减排？</p>
    </div>
    <div v-if="!iscn" class="banner-logo banner-logo-en banner-logo-slow">
      <p class="line1">What is carbon reduction?</p>
      <p>Why is it important?</p>
    </div> -->
    <div v-if="iscn" class="text-explain">
      <!-- <p>以手机为例，每生产一台新手机，平均会产生约49kg碳排放。</p>
      <p>这相当于开86个小时制冷功率980W的空调、开240公里的车，或开6046小时14W的节能灯。</p> -->
      <p class="quote-line">
        *根据《基于项目的温室气体减排量评估技术规范二手交易平台》团体标准及《闲置二手交易碳减排报告》方法学进行测算
      </p>
    </div>
    <div v-if="!iscn" class="text-explain text-explain-en">
      <p class="quote-line">
        Calculations based on the "Project-Based Greenhouse Gas Emission Reduction Evaluation Technical Standards for Second-hand Trading Platforms" group<br/>
        standard and the methodology outlined in the "Carbon Reduction Report for Idle Second-hand Goods Trading."
      </p>
    </div>
    <div class="certificate">
      <img v-if="iscn" src="../assets/cdp.png" class="certificate-item" alt="">
      <img v-else src="../assets/cdp-en.png" class="certificate-item" alt="">
      <img v-if="iscn" src="../assets/sbti.png" class="certificate-item" alt="">
      <img v-else src="../assets/sbti-en.png" class="certificate-item" alt="">
      <img v-if="iscn" src="../assets/baoersen.png" class="certificate-item" alt="">
      <img v-else src="../assets/baoersen-en.png" class="certificate-item" alt="">
    </div>
    <!-- <div class="certificate animate__animated" ref="certificate"></div> -->
    <!-- <div class="split-line"></div> -->
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.title-earth', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })

    new Rellax('.text-quick1', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })

    new Rellax('.text-slow', {
      speed: 0.5,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })

    new Rellax('.logo-earth-star-slow', {
      speed: 0.5,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素certificate进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 当certificate元素进入视口
            if (entry.target.classList.contains('certificate') && entry.isIntersecting) {
              setTimeout(() => {
                document.querySelectorAll('.certificate-item').forEach((item) => {
                  item.classList.add('zoom-in-fast')
                })
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.7
        }
      )
      observer.observe(document.querySelector('.certificate') as Element)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}
.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}
.content {
  position: relative;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 2123px;
  margin: 0 auto;
  color: #000;
  background: #fff;
}
.title-earth {
  font-family: alibaba;
  font-weight: 1000;
  font-size: 80px;
  color: #111111;
  line-height: 80px;
  text-align: center;
  padding-top: 220px;
  position: relative;
}
.text-earth {
  position: absolute;
  top: 358px;
  width: 100%;
  font-size: 34px;
  line-height: 48px;
  text-align: center;
}

.text-earth-en {
  position: absolute;
  top: 223px;
  width: 100%;
  font-size: 68px;
  font-family: alibaba;
  line-height: 68px;
  text-align: center;
  .line1 {
    margin-bottom: 58px;
  }
  .line2 {
    font-size: 34px;
    // font-family: alibaba3;
    line-height: 48px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
  }
}

.logo-earth {
  position: absolute;
  top: 526px;
  left: 50%;
  width: 1049px;
  height: 747px;
  margin-left: -525px;
  .logo-earth-main {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 820px;
    height: 710px;
    margin-left: -410px;
    margin-top: -355px;
    background: url('../assets/green-12.png') no-repeat 0 0/ 100% 100%;
  }
  .logo-earth-star {
    position: absolute;
    top: 0px;
    left: 50%;
    width: 1049px;
    height: 747px;
    margin-left: -525px;
    background: url('../assets/green-11.png') no-repeat 0 0/ 100% 100%;
  }
}

.text-data {
  position: absolute;
  top: 837px;
  left: 50%;
  display: flex;
  justify-content: space-between;
  width: 1700px;
  margin-left: -850px;
  color: #111;
  text-align: center;
  .data {
    flex: 1;
  }
  .data-number {
    font-size: 136px;
    font-family: alibaba;
    line-height: 136px;
  }
  .data-text {
    font-size: 56px;
    font-family: alibaba;
    line-height: 68px;
  }
  .data-text2 {
    font-size: 20px;
    line-height: 28px;
  }
}

.text-data-en {
  left: 50%;
  width: 1459px;
  margin-left: -730px;
  .data-text {
    font-size: 52px;
    color: #000000;
    line-height: 68px;
    font-family: alibaba;
    font-weight: 1000;
  }
  .data-text2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    line-height: 40px;
  }
}

.banner-logo {
  position: absolute;
  top: 764px;
  left: 50%;
  width: 581px;
  height: 225px;
  margin-left: -290px;
  background: url('../assets/middle-2.png') no-repeat 0 0/ 100% 100%;
  p {
    color: #fff;
    font-size: 56px;
    font-family: alibaba;
    line-height: 68px;
    text-align: center;
  }
  .line1 {
    margin-top: 38px;
  }
}

.banner-logo-en {
  width: 627px;
  height: 225px;
  margin-left: -313px;
  background: url('../assets/middle-2-en.png') no-repeat 0 0/ 100% 100%;
  p {
    color: #fff;
    font-size: 46px;
    font-family: alibaba;
    line-height: 54px;
    text-align: center;
  }
  .line1 {
    margin-top: 56px;
  }
}

.text-explain {
  position: absolute;
  top: 1300px;
  width: 100%;
  color: #000;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  .quote-line {
    // margin-top: 23px;
    color: #d7d7d7;
    font-size: 16px;
    line-height: 32px;
  }
}

.text-explain-en {
  .quote-line {
    // width: 1067px;
    margin: 0 auto;
    font-size: 20px;
  }
}

// .certificate {
//   background: url('https://pic1.zhuanstatic.com/zhuanzh/ff05f36a-bac9-4aaf-8789-39210340c07a.png')no-repeat center center;
//   background-size: 100% 100%;
//   margin: 88px auto 240px;
//   width: 1507px;
//   height: 515px;
//   position: absolute;
//   top: 1280px;
//   left: 50%;
//   margin-left: -754px;
//   opacity: 0;
// }
.certificate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 1430px;
  width: 1882px;
  left: 50%;
  margin-left: -941px;
  .certificate-item {
    flex: 0 0 600px;
    width: 600px;
    height: 390px;
    opacity: 0;
  }
}
.show {
  opacity: 1;
}
</style>
